import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import AccountRequests from '../../components/Admin/AccountRequests';

const AccountRequestsPage = () => (
  <PageWrapper>
    <AccountRequests />
  </PageWrapper>
);

export default AccountRequestsPage;
